import React from 'react';
import Table from "../../Table";
import {useAuth} from "../../../helpers/AuthContext";


function CouponsTable({coupons, style, onRefresh, onClickEdit}) {
    const {API_URL, fetch} = useAuth();

    const handleDelete = async (couponId) => {
        if (!window.confirm('Are you sure you want to delete this coupon?')) return;
        try {
            const response = await fetch(`${API_URL}/v1/seller/coupons/${couponId}`, {
                method: 'DELETE'
            });
            if (!response.ok) {
                throw new Error('Failed to delete coupon');
            }
            alert('Coupon deleted successfully');
            // Optionally, you can trigger a refresh of the coupons list here
            if (onRefresh) onRefresh();
        } catch (error) {
            console.error('Error deleting coupon:', error);
            alert('Error deleting coupon');
        }
    };

    const handleEdit = (coupon) => {
        if (onClickEdit) {
            onClickEdit(coupon);
        } else {
            alert(`Edit coupon ${coupon.code}`);
        }
    }

    return (
        <Table
            style={{marginBottom: '2rem', ...style}}
            data={coupons}
            columns={[
                {
                    key: 'code',
                    header: 'Code',
                    label: 'Code'
                },
                {
                    key: 'type',
                    header: 'Type',
                    render: (value) => {
                        const labels = { channel: 'Storewide', product: 'Specific Product', free_shipping: 'Free Shipping', bundle: 'Bundle' };
                        return labels[value] || value;
                    }
                },
                {
                    key: 'discount',
                    header: 'Discount',
                    label: 'Discount',
                    render: (value, row) => {
                        if (row.type === 'free_shipping') return 'Free Shipping';
                        const parts = [];
                        if (row.percentageAmount) parts.push(`${row.percentageAmount}%`);
                        if (row.dollarAmount) parts.push(`$${(row.dollarAmount / 100).toFixed(2)}`);
                        const discount = parts.length ? parts.join(' + ') : 'None';
                        if (row.type === 'bundle') {
                            const min = row.metadata?.bundleMinItems || 2;
                            return `${discount} (${min}+ items)`;
                        }
                        return discount;
                    }
                },
                {
                    key: 'expiresAt',
                    header: 'Expires At',
                    render: (value, row, index) => {
                        if (!value) return 'Never';
                        const date = new Date(value);
                        return date.toLocaleDateString();
                    }
                },
                {
                    key: 'redemptions',
                    header: 'Redemptions',
                    render: (value, row, index) => {
                        let maxRedemptions = row.maxRedemptions ? row.maxRedemptions : 'Unlimited';
                        let numRedemptions = row.numRedemptions ? row.numRedemptions : 0;
                        return `${numRedemptions} / ${maxRedemptions}`;
                    }
                },
                {
                    key: 'Products',
                    header: 'Products',
                    render: (value, row) => {
                        if (row.type === 'channel') return 'All Products';
                        if (row.type === 'free_shipping' || row.type === 'bundle') {
                            if (!value || value.length === 0) return 'All Products';
                            return value.map(p => p.name).join(', ');
                        }
                        if (!value || value.length === 0) return 'No Products';
                        return value.map(p => p.name).join(', ');
                    }
                },
                {
                    key: 'tools',
                    header: 'Tools',
                    render: (value, row, index) => {
                        return (
                            <div style={{display: 'flex', gap: '0.5rem'}}>
                                <button onClick={handleEdit.bind(null, row)}>Edit</button>
                                <button onClick={handleDelete.bind(null, row.uuid)}>Delete</button>
                            </div>
                        );
                    }
                }
            ]}
        />
    );
}

export default CouponsTable;